import SecureLS from 'secure-ls';

// Create secure storage instance
const secureLs = new SecureLS({
  encodingType: 'aes',
  isCompression: true,
  encryptionSecret: process.env.REACT_APP_STORAGE_SECRET,
});

// Create a custom storage adapter for OIDC
export const secureStorage: Storage = {
  getItem: (key: string) => {
    try {
      return secureLs.get(key);
    } catch (e) {
      return null;
    }
  },
  setItem: (key: string, value: string) => {
    secureLs.set(key, value);
  },
  removeItem: (key: string) => {
    secureLs.remove(key);
  },
  clear: () => {
    secureLs.removeAll();
  },
  key: (index: number) => {
    const keys = secureLs.getAllKeys();
    return keys[index] || null;
  },
  length: secureLs.getAllKeys().length
};

// Export the secureLs instance for direct use if needed
export default secureLs; 